export default "__VITE_ASSET__BIA$67QB__"